import { supabase } from '@/lib/supabase';
import {
  domainToRow,
  rowToDomain,
  type RollReviewPricing,
  type RollReviewPricingRow,
} from '../domain/rollReviewPricing';

export const rollReviewPricingRepository = {
  /**
   * Fetch the pricing configuration for a given instructor.
   * Returns null if the instructor has not set up pricing yet (first access).
   */
  async fetchByInstructorId(instructorId: string): Promise<RollReviewPricing | null> {
    const { data, error } = await supabase
      .from('roll_review_pricing')
      .select('*')
      .eq('instructor_id', instructorId)
      .maybeSingle();

    if (error) throw error;
    if (!data) return null;

    return rowToDomain(data as RollReviewPricingRow);
  },

  /**
   * Upsert a pricing configuration.
   * Returns the persisted record (with updated_at from DB).
   */
  async upsert(pricing: RollReviewPricing): Promise<RollReviewPricing> {
    const row = domainToRow(pricing);

    const { data, error } = await supabase
      .from('roll_review_pricing')
      .upsert(row, { onConflict: 'instructor_id' })
      .select('*')
      .single();

    if (error) throw error;

    return rowToDomain(data as RollReviewPricingRow);
  },
};
